"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "VersionFailureReason", {
    enumerable: true,
    get: function() {
        return VersionFailureReason;
    }
});
const VersionFailureReason = {
    ValidationError: 'validation_error',
    VersionLanguagesError: 'version_languages_error',
    SegmentsError: 'segments_error',
    Unknown: 'unknown'
};

//# sourceMappingURL=version-failure-reason.js.map